import { sanityClient } from '@/content/sanity/sanity-client/sanity-client';

const locationPreset = [
  {
    label: 'New West, BC',
    locality: 'New Westminster',
    administrativeAreaLevel1: 'BC',
    position: {
      lat: 49.17652,
      lng: -122.95617,
    },
    imgSrc: '/explore/cities/NewWest.png',
  },
  {
    label: 'Burnaby, BC',
    locality: 'Burnaby',
    administrativeAreaLevel1: 'BC',
    position: {
      lat: 49.243252,
      lng: -122.97419,
    },
    imgSrc: '/explore/cities/Burnaby.png',
  },
  {
    label: 'Port Moody, BC',
    locality: 'Port Moody',
    administrativeAreaLevel1: 'BC',
    position: {
      lat: 49.283054,
      lng: -122.831665,
    },
    imgSrc: '/explore/cities/PortMoody.png',
  },
  {
    label: 'Vancouver, BC',
    locality: 'Vancouver',
    administrativeAreaLevel1: 'BC',
    position: {
      lat: 49.246292,
      lng: -123.116226,
    },
    imgSrc: '/explore/cities/Vancouver.png',
  },
  {
    label: 'Surrey, BC',
    locality: 'Surrey',
    administrativeAreaLevel1: 'BC',
    position: {
      lat: 49.104431,
      lng: -122.801094,
    },
    imgSrc: '/explore/cities/Surrey.png',
  },
  {
    label: 'Prince George, BC',
    locality: 'Prince George',
    administrativeAreaLevel1: 'BC',
    position: {
      lat: 49.104431,
      lng: -122.801094,
    },
    imgSrc: '/explore/cities/PrinceGeorge.png',
  },
];

export function useLocations() {
  return locationPreset;
}

export async function getLocationsFromSanity() {
  const query = `*[_type == "searchLocation"] {
    label,
    locality,
    administrativeAreaLevel1,
    position { lat, lng },
    "imgSrc": imgSrc.asset->url
  }`;
  const locations = await sanityClient.fetch(query);
  return locations;
}

/*
{
    label: 'Kelowna, BC',
    locality: 'Kelowna',
    administrativeAreaLevel1: 'BC',
    position: {
      lat: 49.887951,
      lng: -119.49601,
    },
    imgSrc: '/explore/cities/Kelowna.png',
  },
  {
    label: 'Dawson Creek, BC',
    locality: 'Dawson Creek',
    administrativeAreaLevel1: 'BC',
    position: {
      lat: 55.760555,
      lng: -120.235558,
    },
    imgSrc: '/explore/cities/DawsonCreek.png',
  },
  {
    label: 'Quesnel, BC',
    locality: 'Quesnel',
    administrativeAreaLevel1: 'BC',
    position: {
      lat: 49.104431,
      lng: -122.801094,
    },
    imgSrc: '/explore/cities/Quesnel.png',
  },
  {
    label: 'Williams Lake, BC',
    locality: 'Williams Lake',
    administrativeAreaLevel1: 'BC',
    position: {
      lat: 49.104431,
      lng: -122.801094,
    },
    imgSrc: '/explore/cities/Vancouver.png',
  }, */
